import { validateNumber, validateString } from 'avilatek-utils';
import { PromoCode } from '../../models';

export function validatePromoCodeForm({
  name,
  code,
  value,
  type,
}: Partial<PromoCode>): string {
  if (!validateString(name) || String(name).length > 127) {
    return 'Nombre de la promoción es inválido';
  }

  if (!validateString(code) || String(code).length > 127) {
    return 'Código de la promoción es inválido';
  }

  if (Number(value) < 0 || !validateNumber(value)) {
    return 'El modificador de la promoción es inválido';
  }

  if (!type) {
    return 'El tipo de descuento es inválido';
  }

  return '';
}
